var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let WfPropertiesList = class WfPropertiesList extends LitElement {
    constructor() {
        super(...arguments);
        this.params = [];
        this.workflowVariables = [];
        this.engines = [];
    }
    render() {
        // Définit des valeurs par défaut vides si undefined
        const params = this.params ?? [];
        const workflowVariables = this.workflowVariables ?? [];
        const engines = this.engines ?? [];
        return html `
        <basic-tab
          .options=${[
            { label: msg('Parameters', { id: 'wfProperties.tab.parameters', desc: 'Parameters tab label' }), value: 'parameters' },
            { label: msg('Workflow Variables', { id: 'wfProperties.tab.workflowVariables', desc: 'Workflow variables tab label' }), value: 'workflowVariables' },
            { label: msg('Engines', { id: 'wfProperties.tab.engines', desc: 'Engines tab label' }), value: 'engines' },
        ]}
          .selectedValue=${'parameters'}
        >
          <div slot="parameters">
            <h3>${msg('Global Parameters:', { id: 'wfProperties.title.globalParams', desc: 'Global parameters title' })}</h3>
            <div class="value-container">
            ${params.map((param) => html `
                <basic-card size="small">
                  <p><strong>${param.key}: </strong> ${param.value}</p>
                </basic-card>
              `)}
            </div>
          </div>
          <div slot="workflowVariables">
            <h3>${msg('Workflow Variables:', { id: 'wfProperties.title.workflowVariables', desc: 'Workflow variables title' })}</h3>
            <div class="value-container">
            ${workflowVariables.map((variable) => html `
                <basic-card size="small">
                  <p><strong>${variable.name}: </strong> ${variable.value}</p>
                </basic-card>
              `)}
            </div>
          </div>
          <div slot="engines">
            <h3>${msg('Configured Engines:', { id: 'wfProperties.title.configuredEngines', desc: 'Configured engines title' })}</h3>
            <div class="value-container">
            ${engines.map((engine) => html `
                <basic-card size="small">
                  <p><strong>${engine.name}</strong> - ${engine.description} (${engine.type})</p>
                </basic-card>
              `)}
            </div>
          </div>
        </basic-tab>
    `;
    }
};
WfPropertiesList.styles = css `
    :host {
      display: block;
      font-family: inherit;
    }
    h3 {
      margin-top: 0;
      margin-bottom: 12px;
    }
    .value-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    p {
      white-space: nowrap;        /* keep text on one line */
      overflow: hidden;           /* hide overflow */
      text-overflow: ellipsis;    /* show "..." when clipped */
      display: block;  
      margin: 0;
    }
    div {
      margin-bottom: 8px;
    }
    slot {
      height: 100%;
      overflow: auto;
    }
  `;
__decorate([
    property({ type: Array })
], WfPropertiesList.prototype, "params", void 0);
__decorate([
    property({ type: Array })
], WfPropertiesList.prototype, "workflowVariables", void 0);
__decorate([
    property({ type: Array })
], WfPropertiesList.prototype, "engines", void 0);
WfPropertiesList = __decorate([
    localized(),
    customElement('wf-properties-list')
], WfPropertiesList);
export { WfPropertiesList };
//# sourceMappingURL=WfPropertiesList.js.map